import { Box, Text } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { date as commonDate } from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

import {
  PortfolioChartConfig,
  portfolioFormatterMap,
} from './portfolioChartUtils';
import { BooleanIconGridItem, PortfolioGridItem } from './PortfolioTemplate';

interface PortfolioChartCardsProps<T> {
  selectedBarData: T;
  chartConfig: PortfolioChartConfig<any>;
  chartTitle: string;
  activeFields: (keyof T)[];
  onToggleActiveField?: (selectedField: keyof T) => void;
}

export const PortfolioChartCards = <
  T extends { reportingDate: Util.FullDateStr; [key: string]: Util.Primitive }
>() => {
  // !TODO @eldarshamukhamedov avoid HOCs, this should be implemented using React component composition
  // !TODO @eldarshamukhamedov HOCs should not be capitalized, since that implies they are a component, rather than a function that returns a component
  const Instance = ({
    selectedBarData,
    chartConfig,
    chartTitle,
    activeFields,
    onToggleActiveField,
  }: PortfolioChartCardsProps<T>) => {
    return (
      <Box width="100%">
        <Text fontSize="sm" fontWeight={600} mb="16px">
          Reporting Date:{' '}
          {commonDate.fullDateStrToHumanDateString(
            selectedBarData.reportingDate,
          )}
        </Text>

        <Box maxHeight="550px" overflowY="scroll">
          {_.map(chartConfig, (config, fieldName: keyof T) => {
            if (!config) {
              return null;
            }
            const value = selectedBarData[fieldName];
            const { label, format } = config;
            const formattedValue = portfolioFormatterMap[format](value);
            const isActive = _.includes(activeFields, fieldName);

            return (
              <Box
                key={`${chartTitle}-card-${String(fieldName)}`}
                onClick={
                  onToggleActiveField
                    ? () => onToggleActiveField(fieldName)
                    : undefined
                }
                mb="24px"
              >
                {format === 'boolean' && typeof value === 'boolean' ? (
                  <BooleanIconGridItem
                    label={label}
                    value={value}
                    isActive={isActive}
                    cursor={onToggleActiveField ? 'pointer' : 'default'}
                    defaultTrueDisplayValue="Passed"
                    defaultFalseDisplayValue="Breached"
                  />
                ) : (
                  <PortfolioGridItem
                    label={label}
                    value={formattedValue}
                    isActive={isActive}
                    cursor={onToggleActiveField ? 'pointer' : 'default'}
                  />
                )}
              </Box>
            );
          })}
        </Box>
      </Box>
    );
  };
  return Instance;
};
